import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLastCorrectedTotalsReleaseDate } from '../../hooks/api/correctedTotals';

const LastCorrectedTotalsReleaseDate = ({ workingUnitLocation }) => {
    const { t } = useTranslation('bidding');
    const lastCorrectedTotalsReleaseDate = useLastCorrectedTotalsReleaseDate(workingUnitLocation);

    return (
        <Typography>
            {t('field.sentOn')}: <span style={{ display: 'block' }}>{lastCorrectedTotalsReleaseDate}</span>
        </Typography>
    );
};

export default LastCorrectedTotalsReleaseDate;
